import React, { useState } from 'react'
import { QUIZ_QUESTIONS } from '../content/quiz.generated'
import useServerTimer from '../components/useServerTimer'

const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`

// Knowledge quiz: one question at a time, forward-only, progress bar, hard timer
// with auto-submit at zero. Code is read-only; answers are 1–2 lines. No keys client-side.
export default function QuizStep ({ step, participantId, onAdvance, busy }) {
  const [idx, setIdx] = useState(0)
  const [answers, setAnswers] = useState({})
  const total = QUIZ_QUESTIONS.length
  const q = QUIZ_QUESTIONS[idx]

  const submit = (reason = 'complete') => onAdvance({ answers, reason }, reason)

  const remaining = useServerTimer({
    participantId, stepId: step.stepId, timedSec: step.timedSec,
    stepStartedAt: step.stepStartedAt, remainingSec: step.remainingSec,
    onExpire: () => submit('timeout')
  })

  const next = () => { if (idx + 1 < total) setIdx(idx + 1); else submit('complete') }
  const warn = remaining != null && remaining <= 60 && remaining > 0

  return (
    <div className="study-card quiz">
      <div className="quiz__head">
        <div className="quiz__title">Knowledge Quiz</div>
        {remaining != null && <div className={`quiz__timer${warn ? ' warn' : ''}`}>{fmt(remaining)}</div>}
      </div>
      <div className="quiz__bar"><div className="quiz__bar-fill" style={{ width: `${((idx + 1) / total) * 100}%` }} /></div>
      <div className="quiz__count">Question {idx + 1} of {total}</div>

      <div className="quiz__q">
        <div className="quiz__prompt">{q.prompt}</div>
        {q.code && <pre className="quiz__code"><code>{q.code}</code></pre>}
        <textarea
          className="quiz__answer"
          placeholder="Your answer (1–2 lines). Blank answers can't be scored."
          value={answers[q.id] || ''}
          onChange={e => setAnswers(a => ({ ...a, [q.id]: e.target.value }))}
        />
      </div>

      <div className="quiz__actions">
        <span className="quiz__hint">Forward-only — you can’t return to earlier questions.</span>
        <button className="study-btn study-btn--primary" disabled={busy} onClick={next}>
          {idx + 1 < total ? 'Next →' : 'Submit quiz'}
        </button>
      </div>
    </div>
  )
}
